import styled from 'styled-components';

export const IdField = styled.p`
  margin: 0 0 3px;
  font-style: normal;
  font-weight: 500;
  font-size: 10px;
  line-height: 160%;
  color: #b4b9d9;
`;
